// Shared destination-id -> icon map so the desktop sidebar and the mobile tab
// bar render the same glyph per destination. Kept out of the pure
// view-models/navDestinations selector (which must stay lucide-free).

import { Gauge, History, ScrollText, ShieldAlert, HeartPulse } from 'lucide-react';
import type { DestinationId } from '@/view-models/navDestinations';

export const NAV_ICONS: Record<DestinationId, typeof Gauge> = {
  dashboard: Gauge,
  history: History,
  logs: ScrollText,
  alerts: ShieldAlert,
  pdm: HeartPulse,
};
